import { ContainerModule } from 'inversify';
import { configModule } from '@evercall/config/DI/configModule';
import { domainModule } from '@framework/config/DI/domainModule';
import { messageManagerModule } from './modules/messageManagerModule';
import { analyticsModule } from './modules/analyticsModule';
import { DispatcherModule as UsersDispatcherModule } from '@users/json-rpc-dispatcher';
import { DispatcherModule as DataroomDispatcherModule } from '@dataroom/json-rpc-dispatcher';
import { DispatcherModule as DmPortalDispatcherModule } from '@dm-portal/json-rpc-dispatcher';
import { FileUploadModule as DmPortalFileUploadModule } from '@dm-portal/file-upload';
import { SocketModule as DealroadshowSocketModule } from '@drs/socket-client';
import { SocketModule } from '@evercall/socket-client';
import { DispatcherModule } from '@evercall/json-rpc-dispatcher';
import { FileUploadModule } from '@evercall/file-upload';
import { DispatcherModule as CondorDispatcherModule } from '@condor/json-rpc-dispatcher';

export const rootModules: ContainerModule[] = [
  domainModule,
  configModule,
  messageManagerModule,
  analyticsModule,
  UsersDispatcherModule,
  DataroomDispatcherModule,
  DmPortalDispatcherModule,
  DmPortalFileUploadModule,
  DealroadshowSocketModule,
  DispatcherModule,
  FileUploadModule,
  SocketModule,
  CondorDispatcherModule,
];

export const serverContainerModules = [
  ...rootModules,
];
